module.exports = __webpack_public_path__ + "static/media/02.65cffdcb.png";